import { SimpleGrid, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';
import StatCard, { StatCardProps } from './StatCard';
import { usePreferencesStore } from '../../../stores';
import { LINE_HEIGHT_MAP, LETTER_SPACING_MAP } from '../../../hooks/useAccessibilityStyles';

export interface MetricGridProps {
  metrics: StatCardProps[];
  columns?: number | { base: number; sm?: number; md?: number; lg?: number; xl?: number };
  spacing?: number | string;
  verticalSpacing?: number | string;
  gradientVariant?: 'primary' | 'secondary' | 'tertiary';
}

const MetricGrid = forwardRef<HTMLDivElement, MetricGridProps>(
  (
    {
      metrics,
      columns = { base: 1, sm: 2, md: 3, lg: 4 },
      spacing = 'md',
      verticalSpacing,
      gradientVariant = 'primary',
    },
    ref
  ) => {
    const theme = useMantineTheme();
    const lineSpacing = usePreferencesStore((state) => state.lineSpacing);
    const letterSpacingPref = usePreferencesStore((state) => state.letterSpacing);

    const accessibilityStyles = {
      lineHeight: LINE_HEIGHT_MAP[lineSpacing],
      letterSpacing: LETTER_SPACING_MAP[letterSpacingPref],
    };

    return (
      <SimpleGrid
        ref={ref}
        cols={columns}
        spacing={spacing}
        verticalSpacing={verticalSpacing || spacing}
      >
        {metrics.map((metric, index) => (
          <StatCard
            key={index}
            gradientVariant={gradientVariant}
            {...metric}
          />
        ))}
      </SimpleGrid>
    );
  }
);

MetricGrid.displayName = 'MetricGrid';

export default MetricGrid;
